import { I18nProvider } from "@refinedev/core";
import { useCustomTranslation } from "./useCustomTranslation";

export function useI18nProvider(): I18nProvider {
  const { t, i18n } = useCustomTranslation();
  return {
    translate: (key: string, params: object) => {
      return t(key, params as any);
    },
    changeLocale: function (lang: string) {
      i18n.changeLanguage(lang).then();
    },
    getLocale: () => i18n.language,
  };
}
